/*
 * Module for a select field which publishes when its value changes as well as listen for its dependent field(s) to change
 * so it reloads its options.
*/

rs.module("controls/forms/dynamicform/selectfield",

    ["controls/forms/dynamicform", "common/select-helper"],

    function (dynamicForm, selectHelper) {

        //
        // Initialize
        //
        function initialize(formIdentifier, fieldId, includeEmptyItem) {

            // If there is no Id, there's nothing to do.
            if (!fieldId) {
                return;
            }

            var dynamicFormInstance = dynamicForm.getForm(formIdentifier);

            // Get the field and helper for working with the select list
            var field = $.js(fieldId);
            var fieldSelectHelper = selectHelper.getHelper(field);

            // When this value changes, notify the form so dependent fields can be updated.
            field.change(function () {

                // Notify the form that this field has changed
                dynamicFormInstance.fieldChanged(fieldId, _getSelectedValue());
            });

            // Listen for when new field state is sent in, such as when a dependency changes and
            // new state is retrieved from the backend.
            dynamicFormInstance.onFieldStateChanged(

                // This field
                fieldId,

                // Current value producer
                _getSelectedValue,

                // New State callback
                function (fieldState) {
                    if (fieldState) {
                        if (fieldState.items) {
                            fieldSelectHelper.replaceOptions(fieldState.items, { withBlank: includeEmptyItem });
                        }
                        else {
                            fieldSelectHelper.clearOptions();
                        }
                        fieldSelectHelper.setValue(fieldState.value);
                    }

                });

            // look for a checkbox which controls the enabled/disabled state
            field
                .closest('.form-group')
                .find(`:checkbox[data-selection-for='${fieldId}']`)
                .change(function () {
                    // toggle enabled/disabled state
                    $(field).prop('disabled', function (i, current) { return !current; })

                    // go through the selecthelper to fix up the selectpicker
                    fieldSelectHelper.setDisabled($(field).prop('disabled'));

                    // clear selected value
                    fieldSelectHelper.setValue(null);
                });

            //
            // Gets the currently selected value 
            //
            function _getSelectedValue() {
                return field.val();
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);